import React from "react";
import {
    BlockCollab,
    BlockTitleCollab,
    BadgeCollab,
    FieldGrid,
    Field,
    FieldInput,
    FieldSelectReal,
    Req,
    SInput,
    SPhoneInputStyle,
} from "../index";
import { Controller, useFormContext } from "react-hook-form";
import { ErrorMessage } from "../../../common/styles";

export default function BlockUrgence() {
    const {
        control,
        formState: { errors },
    } = useFormContext();
    return (
        <BlockCollab>
            <BlockTitleCollab>
                Contact d'urgence{" "}
                <BadgeCollab>À compléter par vous</BadgeCollab>
            </BlockTitleCollab>

            <FieldGrid>
                <Field>
                    <label>
                        Nom et prénom <Req>*</Req>
                    </label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <SInput
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    onChange={(_, i) => onChange(i.value)}
                                    error={
                                        errors?.emergency_contacts?.[0]
                                            ?.full_name
                                    }
                                />
                            );
                        }}
                        name="emergency_contacts[0].full_name"
                    />
                    {errors?.emergency_contacts?.[0]?.full_name && (
                        <ErrorMessage
                            content={
                                errors?.emergency_contacts?.[0]?.full_name
                                    ?.message
                            }
                        />
                    )}
                </Field>
                <Field>
                    <label>
                        Relation <Req>*</Req>
                    </label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <SInput
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    onChange={(_, i) => onChange(i.value)}
                                    error={
                                        errors?.emergency_contacts?.[0]
                                            ?.relationship
                                    }
                                />
                            );
                        }}
                        name="emergency_contacts[0].relationship"
                    />
                    {errors?.emergency_contacts?.[0]?.relationship && (
                        <ErrorMessage
                            content={
                                errors?.emergency_contacts?.[0]?.relationship
                                    ?.message
                            }
                        />
                    )}
                </Field>
                <Field>
                    <label>Email</label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <SInput
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    onChange={(_, i) => onChange(i.value)}
                                    error={
                                        errors?.emergency_contacts?.[0]?.email
                                    }
                                />
                            );
                        }}
                        name="emergency_contacts[0].email"
                    />
                    {errors?.emergency_contacts?.[0]?.email && (
                        <ErrorMessage
                            content={
                                errors?.emergency_contacts?.[0]?.email?.message
                            }
                        />
                    )}
                </Field>
                <Field>
                    <label>
                        Téléphone <Req>*</Req>
                    </label>
                    <Controller
                        control={control}
                        render={({
                            field: { onChange, onBlur, value, name, ref },
                        }) => {
                            const formatValue = value?.startsWith("+")
                                ? value
                                : "+" + value;
                            return (
                                <SPhoneInputStyle
                                    international
                                    countryCallingCodeEditable={false}
                                    defaultCountry={"CH"}
                                    value={formatValue}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    error={
                                        errors?.emergency_contacts?.[0]
                                            ?.phone_number
                                    }
                                />
                            );
                        }}
                        name="emergency_contacts[0].phone_number"
                    />
                    {errors?.emergency_contacts?.[0]?.phone_number && (
                        <ErrorMessage
                            content={
                                errors?.emergency_contacts?.[0]?.phone_number
                                    ?.message
                            }
                        />
                    )}
                </Field>
            </FieldGrid>
        </BlockCollab>
    );
}
